import { useCurrentUserIntegrations } from '../../../views/Integration/useCurrentUserIntegrations'
import { ActionSuggestion } from '../model'
import { useFilterSuggestions } from './useFilterSuggestions'
import { useAppSelector } from '../../../store/hooks'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'

export const useMeetingExportSuggestions = () => {
  const roomSession = useAppSelector(selectRoomSession)
  const { meetingExportSupportedIntegrations } = useCurrentUserIntegrations()

  const suggestions = roomSession
    ? meetingExportSupportedIntegrations.map(
        ({ serviceId }): ActionSuggestion => ({
          actionType: 'exportMeetingSummary',
          serviceId: serviceId,
          roomSession: roomSession,
        }),
      )
    : []

  return useFilterSuggestions(suggestions, 'exportMeetingSummary')
}
